export default [
  {
    value: 'male',
    label: 'Masculino',
  },
  {
    value: 'female',
    label: 'Feminino',
  },
  {
    value: 'non-binary',
    label: 'Não-binário',
  },
];
